import script from "./selectedGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./selectedGoods.vue?vue&type=script&setup=true&lang=js"

import "./selectedGoods.vue?vue&type=style&index=0&id=9e9b5e20&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e9b5e20"]])

export default __exports__